import axios, { AxiosResponse } from 'axios';
import { ProductListRequest, ProductListResponse, ProductValue } from '@/venit/services/model/techpubs-cms';

// Inline until mvnd process-classes -Ptypescript-api is run
export interface ProductSaveRequest {
  product: ProductValue;
}

export interface ProductSaveResponse {
  product: ProductValue;
}

export default class ProductsManagementService {

  public list(request: ProductListRequest): Promise<AxiosResponse<ProductListResponse>> {
    return axios.post<ProductListResponse>('/api/admin/products/list', request);
  }

  public save(request: ProductSaveRequest): Promise<AxiosResponse<ProductSaveResponse>> {
    return axios.post<ProductSaveResponse>('/api/admin/products/save', request);
  }

}
